export default {"src":"https://images-cdn.curipod.com/d-bdb94e66/_next/static/media/tuesday.11120932.svg","height":157,"width":450};